import React, { useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  FDList, FDListItem, FDListItemAvatar, FDListItemText,
} from '@facet-wealth/design';
import { getBorder, getBorderRadius } from 'Components/utils';
import { dataAttrs, testAttr } from 'Helpers/Testing';

const useStyles = buildUseStyles('FinancialInstitutionList', (theme) => ({
  // TODO: remove this once FD supports it out of the box
  root: {
    '& .FD-MuiListItem-root:first-of-type': {
      marginTop: 0,
    },
    '& .FD-MuiListItem-root': {
      marginTop: theme.spacing(1),
    },
    '& .FD-MuiListItemText-secondary': {
      wordBreak: 'break-word',
    },
  },
  rootWithOnClick: {
    '& .FD-MuiListItem-root': {
      ...getBorder(theme, { all: true }),
      ...getBorderRadius(theme.radius.md, { all: true }),
    },
  },
}));

const FinancialInstitutionList = ({
  onClick,
  institutions,
  nameAttr,
  baseURLAttr,
  iconAttr,
}) => {
  const classes = useStyles();
  return useMemo(() => {
    return (
      <div className={classNames(classes.root, { [classes.rootWithOnClick]: !!onClick })}>
        <FDList>
          {institutions.map(institution => {
            const hasName = !!institution.attr(nameAttr);
            return (
              <FDListItem
                {...dataAttrs('institution-list-item', institution, {
                  [testAttr.dataName]: institution.attr(nameAttr)?.toLowerCase(),
                })}
                key={institution.id()}
                data-test={['institution-card', institution.attr(nameAttr)?.toLowerCase()].filter(Boolean).join('-')}
                onClick={onClick ? () => onClick(institution) : undefined}
              >
                <FDListItemAvatar
                  src={institution.attr(iconAttr)}
                  alt="Bank Logo"
                />
                <FDListItemText
                  color={onClick ? undefined : 'disabled'}
                  primaryText={hasName ? institution.attr(nameAttr) : institution.attr(baseURLAttr)}
                  secondaryText={hasName ? institution.attr(baseURLAttr) : undefined}
                />
              </FDListItem>
            );
          })}
        </FDList>
      </div>
    );
  }, [institutions, onClick, nameAttr, baseURLAttr, iconAttr]);
};

FinancialInstitutionList.defaultProps = {
  onClick: undefined,
};

FinancialInstitutionList.propTypes = {
  onClick: PropTypes.func,
  institutions: PropTypes.array.isRequired,
  nameAttr: PropTypes.string.isRequired,
  baseURLAttr: PropTypes.string.isRequired,
  iconAttr: PropTypes.string.isRequired,
};

export default FinancialInstitutionList;
